import React from 'react';
import { Venues } from '@weddingspot/ws-api-client';
import { format } from 'date-fns';

import style from './UpcomingEvents.module.scss';

const UpcomingEvent = ({ event }: { event: Venues.VenueUpcomingEvent }) => {
    let startDate = format(new Date(event.start_date), 'MMM d, Y');
    let endDate = format(new Date(event.end_date), 'MMM d, Y');
    let dateString = startDate;
    if (startDate !== endDate) {
        dateString += ' - ' + endDate;
    }
    let timeString = '';
    if (!!event.start_time && !!event.end_time) {
        let startTime = format(new Date(event.start_date + ' ' + event.start_time), 'h:mma');
        let endTime = format(new Date(event.end_date + ' ' + event.end_time), 'h:mma');
        timeString = startTime + ' - ' + endTime;
    }
    return (
        <div className={style.event}>
            <div className={style.icon}>
                <i className='icon-hb-nx-calendar-star' />
            </div>
            <div className={style.data}>
                <h3>{event.name}</h3>
                <p>
                    {dateString}
                    {timeString && <span>{` ${timeString}`}</span>}
                </p>
                <a href={event.website} target='_blank'>
                    {event.website}
                </a>
            </div>
        </div>
    );
};

export default UpcomingEvent;
